import { withMobileDetection } from '../../components';

import Base from './Base';

export default withMobileDetection(Base);
